export default class SettingsController {
    constructor($rootScope, $state, AuthenticationService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.AuthenticationService = AuthenticationService;
    }
}
SettingsController.$inject = ['$rootScope', '$state', 'AuthenticationService'];
